import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import FormPage from './pages/FormPage';
import Dashboard from './pages/Dashboard';
import Statistics from './pages/Statistics';
import TemplatesPage from './pages/TemplatesPage';
import UserManagement from './pages/UserManagement';
import AdminSubmissions from './pages/AdminSubmissions';
import MyOrders from './pages/MyOrders';
import SubmissionDetails from './pages/SubmissionDetails';
import UserProfile from './pages/UserProfile';
import CustomStatisticsPage from './pages/CustomStatisticsPage';
import ClientVersionNotice from './components/ClientVersionNotice';
import './services/debug'; // Import debug utilities

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <ClientVersionNotice />
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/form"
              element={
                <ProtectedRoute>
                  <FormPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <AdminRoute>
                  <Dashboard />
                </AdminRoute>
              }
            />
            <Route
              path="/dashboard/statistics"
              element={
                <AdminRoute>
                  <Statistics />
                </AdminRoute>
              }
            />
            <Route
              path="/statistics/custom"
              element={
                <AdminRoute>
                  <CustomStatisticsPage />
                </AdminRoute>
              }
            />
            <Route
              path="/dashboard/users"
              element={
                <AdminRoute>
                  <UserManagement />
                </AdminRoute>
              }
            />
            <Route
              path="/dashboard/submissions"
              element={
                <AdminRoute>
                  <AdminSubmissions />
                </AdminRoute>
              }
            />
            <Route
              path="/dashboard/submissions/:id"
              element={
                <AdminRoute>
                  <SubmissionDetails />
                </AdminRoute>
              }
            />
            <Route
              path="/my-orders"
              element={
                <ProtectedRoute>
                  <MyOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-orders/:id"
              element={
                <ProtectedRoute>
                  <SubmissionDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <TemplatesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/form/template/:templateId"
              element={
                <ProtectedRoute>
                  <FormPage />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/form" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
